export const MARGIN = {
  homepageX: '5.5vw',
  homepageB: '24px'
};

export const HEIGHT = {
  navbar: '98px'
};
